<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="TOC1"><a href="#/Foreword">Foreword, by Guy Morse III, BAA Board of Governor</a></p>
<p class="TOC"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="TOC"><a href="#/Introduction">Introduction</a></p>
<p class="TOC1"><a href="#/Chapter1">1. Champion Wreaths from Greece</a></p>
<p class="TOC"><span href="#/Chapter2" title="Link target outside of Sample">2. Start Line, Finish Line, and Everything Between</span></p>
<p class="TOC"><span href="#/Chapter3" title="Link target outside of Sample">3. Finisher Medals</span></p>
<p class="TOC"><span href="#/Chapter4" title="Link target outside of Sample">4. Relationship with Ohme-Hochi 30K in Japan</span></p>
<p class="TOC"><span href="#/Chapter5" title="Link target outside of Sample">5. Athlete Villages</span></p>
<p class="TOC"><span href="#/Chapter6" title="Link target outside of Sample">6. Evolution of Media Coverage</span></p>
<p class="TOC"><span href="#/Chapter7" title="Link target outside of Sample">7. Monuments and Statues</span></p>
<p class="TOC1"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?7440e6e3